/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ExceptionData } from './ExceptionData';
import {
    ExceptionDataFromJSON,
    ExceptionDataFromJSONTyped,
    ExceptionDataToJSON,
} from './ExceptionData';
import type { I18nInfo } from './I18nInfo';
import {
    I18nInfoFromJSON,
    I18nInfoFromJSONTyped,
    I18nInfoToJSON,
} from './I18nInfo';
import type { Exception } from './Exception';
import {
    ExceptionFromJSON,
    ExceptionFromJSONTyped,
    ExceptionToJSON,
} from './Exception';

/**
 * 
 * @export
 * @interface Ptw100UnauthorizedException
 */
export interface Ptw100UnauthorizedException {
    /**
     * 
     * @type {string}
     * @memberof Ptw100UnauthorizedException
     */
    readonly targetSite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100UnauthorizedException
     */
    readonly message?: string | null;
    /**
     * 
     * @type {ExceptionData}
     * @memberof Ptw100UnauthorizedException
     */
    data?: ExceptionData | null;
    /**
     * 
     * @type {Exception}
     * @memberof Ptw100UnauthorizedException
     */
    innerException?: Exception;
    /**
     * 
     * @type {string}
     * @memberof Ptw100UnauthorizedException
     */
    helpLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100UnauthorizedException
     */
    source?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100UnauthorizedException
     */
    hResult?: number;
    /**
     * 
     * @type {string}
     * @memberof Ptw100UnauthorizedException
     */
    readonly stackTrace?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100UnauthorizedException
     */
    code?: number;
    /**
     * 
     * @type {I18nInfo}
     * @memberof Ptw100UnauthorizedException
     */
    i18n?: I18nInfo;
    /**
     * 
     * @type {string}
     * @memberof Ptw100UnauthorizedException
     */
    $type?: Ptw100UnauthorizedExceptionTypeEnum;
}


/**
 * @export
 */
export const Ptw100UnauthorizedExceptionTypeEnum = {
    PtwPtw100AppZeroCoreSharedExceptionsPtw100UnauthorizedExceptionPtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100UnauthorizedException, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type Ptw100UnauthorizedExceptionTypeEnum = typeof Ptw100UnauthorizedExceptionTypeEnum[keyof typeof Ptw100UnauthorizedExceptionTypeEnum];



/**
 * Check if a given object implements the Ptw100UnauthorizedException interface.
 */
export function instanceOfPtw100UnauthorizedException(value?: unknown): value is Ptw100UnauthorizedException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(Ptw100UnauthorizedExceptionTypeEnum)[0];
}

export function Ptw100UnauthorizedExceptionFromJSON(json: any): Ptw100UnauthorizedException {
    return Ptw100UnauthorizedExceptionFromJSONTyped(json, false);
}

export function Ptw100UnauthorizedExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ptw100UnauthorizedException {
    if (json == null) {
        return json;
    }
    return {
        
        'targetSite': json['targetSite'] == null ? undefined : json['targetSite'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ExceptionDataFromJSON(json['data']),
        'innerException': json['innerException'] == null ? undefined : ExceptionFromJSON(json['innerException']),
        'helpLink': json['helpLink'] == null ? undefined : json['helpLink'],
        'source': json['source'] == null ? undefined : json['source'],
        'hResult': json['hResult'] == null ? undefined : json['hResult'],
        'stackTrace': json['stackTrace'] == null ? undefined : json['stackTrace'],
        'code': json['code'] == null ? undefined : json['code'],
        'i18n': json['i18n'] == null ? undefined : I18nInfoFromJSON(json['i18n']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function Ptw100UnauthorizedExceptionToJSON(value?: Omit<Ptw100UnauthorizedException, 'targetSite'|'message'|'stackTrace'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'data': ExceptionDataToJSON(value['data']),
        'innerException': ExceptionToJSON(value['innerException']),
        'helpLink': value['helpLink'],
        'source': value['source'],
        'hResult': value['hResult'],
        'code': value['code'],
        'i18n': I18nInfoToJSON(value['i18n']),
        '$type': value['$type'],
    });
}

